import { createContext } from "react";
import useAttachmentsByStageId from "../hooks/data/useAttachmentsByStageId";

export interface IStageAttachmentsContext extends ReturnType<typeof useAttachmentsByStageId> {

};

const StageAttachmentsContext = createContext<IStageAttachmentsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default StageAttachmentsContext